"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Address_1 = tslib_1.__importDefault(require("./Address"));
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
/**
 * Value object, most amazing class ever created
 * Previously known as KevinTheKermit
 */
class AddressGroup extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '1yr vast',
        description: 'The name of the KevinTheKermit',
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", String)
], AddressGroup.prototype, "name", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'Duration of the particular KevinTheKermit in years',
        example: '1',
    }),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", String)
], AddressGroup.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '513866', description: 'The campaign id, as stored in SAP and CDT' }),
    tslib_1.__metadata("design:type", String)
], AddressGroup.prototype, "cdtId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => Address_1.default),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Array)
], AddressGroup.prototype, "addresses", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.GetNextBestOfferResponseOfferIncentiveV2),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Array)
], AddressGroup.prototype, "incentives", void 0);
exports.default = AddressGroup;
